"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get PagedResponseImpl () {
        return PagedResponseImpl;
    },
    get PagedResponseV3Impl () {
        return PagedResponseV3Impl;
    },
    get constructUrl () {
        return constructUrl;
    }
});
const _ = require(".");
const _catchError = require("~/helpers/catchError");
const _extractProps = require("~/helpers/extractProps");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
// handle fields[] in array format
function objectToSearchParams(obj) {
    const params = new URLSearchParams();
    Object.entries(obj).forEach(([key, value])=>{
        if (Array.isArray(value)) {
            value.forEach((item)=>{
                if (item !== null && item !== undefined) {
                    params.append(key, String(item));
                }
            });
        } else if (value !== null && value !== undefined) {
            params.append(key, String(value));
        }
    });
    return params;
}
function constructUrl({ baseUrl, path, query }) {
    let url = `${baseUrl}${path}`;
    if (query) {
        const queryStr = objectToSearchParams(query).toString();
        url = `${url}?${queryStr}`;
    }
    return url;
}
let PagedResponseImpl = class PagedResponseImpl {
    constructor(list, args = {}, additionalProps){
        var _args_count;
        const { offset, limit } = (0, _.extractLimitAndOffset)(args);
        let count = (_args_count = args.count) != null ? _args_count : null;
        if (count !== null) count = +count;
        this.list = list;
        if (count !== null && count !== undefined) {
            var _this_pageInfo_isFirstPage;
            this.pageInfo = {
                totalRows: +count
            };
            this.pageInfo.page = offset ? offset / limit + 1 : 1;
            this.pageInfo.pageSize = limit;
            this.pageInfo.isFirstPage = (_this_pageInfo_isFirstPage = this.pageInfo.isFirstPage) != null ? _this_pageInfo_isFirstPage : this.pageInfo.page === 1;
            this.pageInfo.isLastPage = this.pageInfo.page >= (Math.ceil(this.pageInfo.totalRows / this.pageInfo.pageSize) || 1);
            if (this.pageInfo.page % 1 !== 0) {
                this.pageInfo.offset = offset;
                delete this.pageInfo.page;
            }
            if (offset && offset >= +count) {
                _catchError.NcError.invalidOffsetValue(offset);
            }
        }
        if (additionalProps) Object.assign(this, additionalProps);
    }
};
let PagedResponseV3Impl = class PagedResponseV3Impl {
    constructor(pagedResponse, { context, baseUrl = '', tableId, nestedNextPageAvail, nestedPrevPageAvail, queryParams = {} }){
        this.list = pagedResponse.list;
        const pageInfo = {};
        const commonProps = {
            baseUrl,
            path: `/api/v3/data/${context.base_id}/${tableId}/records`
        };
        const commonQueryParams = (0, _extractProps.extractProps)(queryParams || {}, [
            'sort',
            'where',
            'viewId',
            'pageSize',
            'fieldIdOnResult',
            'fields',
            'nestedPage'
        ]);
        if (!pagedResponse.pageInfo.isFirstPage && pagedResponse.pageInfo.page) {
            pageInfo.prev = constructUrl(_extends({}, commonProps, {
                query: _extends({}, commonQueryParams, {
                    page: pagedResponse.pageInfo.page - 1
                })
            }));
        }
        if (!pagedResponse.pageInfo.isLastPage && pagedResponse.pageInfo.page) {
            pageInfo.next = constructUrl(_extends({}, commonProps, {
                query: _extends({}, commonQueryParams, {
                    page: pagedResponse.pageInfo.page + 1
                })
            }));
        }
        const nestedPage = Math.max(+(queryParams == null ? void 0 : queryParams.nestedPage), 1);
        if (nestedNextPageAvail) {
            pageInfo.nestedNext = constructUrl(_extends({}, commonProps, {
                query: _extends({}, commonQueryParams, {
                    page: pagedResponse.pageInfo.page,
                    nestedPage: nestedPage + 1
                })
            }));
        }
        if (nestedPrevPageAvail) {
            pageInfo.nestedPrev = constructUrl(_extends({}, commonProps, {
                query: _extends({}, commonQueryParams, {
                    page: pagedResponse.pageInfo.page,
                    nestedPage: nestedPage - 1
                })
            }));
        }
        this.pageInfo = pageInfo;
    }
};
